export default __webpack_public_path__ + "static/media/Maestro.f9006a5d.svg";